/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Push_Rationale_ReminderInputs */

const en_us2_push_rationale_reminder = /** @type {(inputs: Push_Rationale_ReminderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`One reminder a day, at the time you choose.`)
};

const pt_br2_push_rationale_reminder = /** @type {(inputs: Push_Rationale_ReminderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um lembrete por dia, no horário que você escolher.`)
};

const es_419_push_rationale_reminder = /** @type {(inputs: Push_Rationale_ReminderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un recordatorio al día, a la hora que elijas.`)
};

const pt_pt2_push_rationale_reminder = /** @type {(inputs: Push_Rationale_ReminderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um lembrete por dia, à hora que escolheres.`)
};

const fr_fr2_push_rationale_reminder = /** @type {(inputs: Push_Rationale_ReminderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un rappel par jour, à l'heure que tu choisis.`)
};

const de_de2_push_rationale_reminder = /** @type {(inputs: Push_Rationale_ReminderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eine Erinnerung pro Tag, zur Uhrzeit deiner Wahl.`)
};

const it_it2_push_rationale_reminder = /** @type {(inputs: Push_Rationale_ReminderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un promemoria al giorno, all'ora che scegli.`)
};

/**
* | output |
* | --- |
* | "One reminder a day, at the time you choose." |
*
* @param {Push_Rationale_ReminderInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const push_rationale_reminder = /** @type {((inputs?: Push_Rationale_ReminderInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Push_Rationale_ReminderInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_push_rationale_reminder(inputs)
	if (locale === "es-419") return es_419_push_rationale_reminder(inputs)
	if (locale === "pt-PT") return pt_pt2_push_rationale_reminder(inputs)
	if (locale === "fr-FR") return fr_fr2_push_rationale_reminder(inputs)
	if (locale === "de-DE") return de_de2_push_rationale_reminder(inputs)
	if (locale === "it-IT") return it_it2_push_rationale_reminder(inputs)
	return en_us2_push_rationale_reminder(inputs)
});
export { push_rationale_reminder as "push.rationale_reminder" }